// extracted by mini-css-extract-plugin
module.exports = {"info":"TwoFactor_info__2JOcV","icon":"TwoFactor_icon__34uxY","overlaying":"TwoFactor_overlaying__2tkMK","inputWrapper":"TwoFactor_inputWrapper__17cQ9"};